import { ComposeViewState } from 'owa-mail-compose-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';

export default function fixInlineImageSrc(viewState: ComposeViewState) {
    return function(cidOrName: string) {
        if (viewState.attachmentWell && viewState.attachmentWell.inlineAttachments) {
            for (const attachmentData of viewState.attachmentWell.inlineAttachments) {
                const attachment = getAttachment(attachmentData.attachmentId);
                if (
                    attachment &&
                    attachment.thumbnailImage &&
                    attachment.model &&
                    (attachment.model.ContentId == cidOrName || attachment.model.Name == cidOrName)
                ) {
                    return {
                        url: attachment.thumbnailImage.url,
                        contentId: attachment.model.ContentId,
                    };
                }
            }
        }

        return null;
    };
}
